import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {Headers, RequestOptions} from '@angular/http';
import {environment} from '../../environments/environment';

@Injectable()
export class EnvLoadService {
    public envCd = '';

    public ssoUrl = '';
    public portalUrl = '';
    public noticeUrl = '';
    public permissionUrl = '';
    public chatbotUrl = '';
    public supportUrl = '';
    public extnUrl = '';
    public notiUrl = '';
    public brandUrl = '';
    public alertnowInternalOpenApiUrl = '';
    public opsnow360Url = '';

    constructor(private http: Http) { }

    initializeApp(): Promise<any> {
        return new Promise((resolve, reject) => {
            console.log(`initializeApp:: inside promise`);

            setTimeout(() => {
                console.log(`initializeApp:: inside setTimeout`);
                // doing something

                resolve();
            }, 5000);
        });
    }

    setEnv(): Promise<any> {
        console.log(`getSettings:: before http.get call`);

        const options = new RequestOptions({withCredentials: true });

        options.headers = new Headers();
        options.headers.append('Content-Type', 'application/json');

        const protocol = window.location.protocol;
        const domainList = window.location.href.replace('http://', '').replace('https://', '').split('/')[0].split(':')[0].split('.');
        const domainPrepix = domainList[0];
        domainList[0] = '';
        const domain = domainList.join('.');
        domainList[1] = '';
        domainList.shift();
        const baseDomain = domainList.join('.');
        const promise = this.http
        .get(`${environment.apiUrl}/api/v1/1/common/profile`, options)
        .toPromise()
        .then(settings => {
            this.envCd = global['envCd'] = settings.json().data;
            switch (this.envCd) {
                case 'chn':
                    this.ssoUrl = `https://sso${domain}/`;
                    this.portalUrl = `https://service${domain}/`;
                    this.noticeUrl = `https://service${domain}/notice`;
                    this.permissionUrl = `//service${domain}/permission`;
                    this.chatbotUrl = '';
                    this.supportUrl = '';
                    this.extnUrl = `https://alertnowextn${domain}`;
                    this.notiUrl = `https://alertnowextapi${domain}`;
                    this.brandUrl = `https://www.opsnow.cn`;
                    this.alertnowInternalOpenApiUrl = '';
                    this.opsnow360Url = '';
                    break;
                case 'prdecs':
                case 'prdeks':
                case 'prd':
                    this.ssoUrl = `https://auth${domain}/`;
                    this.portalUrl = `https://service${domain}/`;
                    if (domain === '.doosan.com') {
                        this.portalUrl = `https://cloudmpservice${domain}/`;
                    } else if (domain === '.hyundaimovex.com') {
                        this.portalUrl = `https://cloudservice${domain}/`;
                    } else if (domain === '.wins21.com') {
                        this.portalUrl   = `https://cloudservice${domain}/`;
                    } else if (domain === '.sckcorp.co.kr') {
                        this.portalUrl = `https://msp${domain}/`;
                    } else if (domain === '.spintech.co.kr') {
                        this.portalUrl = `https://msp${domain}/`;
                    } else if (domain === '.comtec.co.kr') {
                        this.portalUrl = `https://oasis${domain}/`;
                    }
                    this.noticeUrl = `https://service${domain}/notice`;
                    this.permissionUrl = `//service${domain}/permission`;
                    this.chatbotUrl = `https://opsbot-front-prod.a.okc1.opsnow.com/`;
                    this.supportUrl = `https://support.bespinglobal.com/login`;
                    this.extnUrl = `https://alertnowextn.opsnow.com`;
                    this.notiUrl = `https://alertnowextapi.opsnow.com`;
                    this.brandUrl = `https://www.opsnow.com`;
                    this.alertnowInternalOpenApiUrl = `${protocol}//alertnowinternalapi.an.opsnow.com/`;
                    this.opsnow360Url = `${protocol}//console${domain}/`;
                    if (domain === '.onidemo.com') {
                        this.opsnow360Url = '';
                        this.portalUrl = `https://service.opsnow.com/`;
                    }
                    break;
                case 'sec-prod':
                    this.ssoUrl = `https://sso${domain}/`;
                    this.portalUrl = `https://service${domain}/`;
                    this.noticeUrl = `https://service${domain}/notice`;
                    this.permissionUrl = `//service${domain}/permission`;
                    this.chatbotUrl = '';
                    this.supportUrl = `https://support.sec-alertnow.com/login`;
                    this.extnUrl = `https://alertnowextn${domain}`;
                    this.notiUrl = `https://alertnowextapi${domain}`;
                    this.brandUrl = `https://service.sec-alertnow.com`;
                    this.opsnow360Url = '';
                    break;
                case 'loc':
                    this.ssoUrl = `https://authstage${baseDomain}/`;
                    //this.ssoUrl = `https://ssoitg.gstg.opsnow.com/`;
                    this.portalUrl = `https://servicedev${baseDomain}/`;
                    this.noticeUrl = `https://servicedev${baseDomain}/notice`;
                    this.permissionUrl = `//servicedev${domain}/permission`;
                    this.chatbotUrl = `https://opsbot-front-dev.dev.opsnow.com/`;
                    this.supportUrl = `https://dev-support.bespinglobal.com/login`;
                    this.extnUrl = `https://alertnowextndev${domain}`;
                    this.notiUrl = `https://alertnowextapidev${domain}`;
                    this.brandUrl = `https://ocp-opsnow-brand-site-sandbox.dev.opsnow.com`;
                    this.alertnowInternalOpenApiUrl = `http://localhost:8084`;
                    this.opsnow360Url = `${protocol}//consoledev${domain}/`;
                    if (domain === '.onidemo.com') {
                        this.opsnow360Url = '';
                    }
                    break;
                case 'dev':
                case 'devecs':
                case 'deveks':
                    this.portalUrl = `https://servicedev.opsnow.com/`;
                    this.noticeUrl = `https://servicedev.opsnow.com/notice`;
                    this.permissionUrl = `https://servicedev.opsnow.com/permission`;
                    this.chatbotUrl = `https://opsbot-front-dev.dev.opsnow.com/`;
                    this.supportUrl = `https://dev-support.bespinglobal.com/login`;
                    this.extnUrl = `https://alertnowextndev.opsnow.com`;
                    this.notiUrl = `https://alertnowextapidev.opsnow.com`;
                    this.brandUrl = `https://ocp-opsnow-brand-site-sandbox.dev.opsnow.com`;
                    this.alertnowInternalOpenApiUrl = `${protocol}//alertnowinternalapidev.opsnow.com/`;
                    this.opsnow360Url = `${protocol}//consoledev${domain}/`;
                    if (domain === '.onidemo.com') {
                        this.opsnow360Url = '';
                    }
                	break;
                default:
                    this.ssoUrl = `https://authstage${baseDomain}/`;
                    this.portalUrl = `https://servicedev${baseDomain}/`;
                    this.noticeUrl = `https://servicedev${baseDomain}/notice`;
                    this.permissionUrl = `//servicedev${baseDomain}/permission`;
                    this.chatbotUrl = `https://opsbot-front-dev.dev.opsnow.com/`;
                    this.supportUrl = `https://dev-support.bespinglobal.com/login`;
                    this.extnUrl = `https://alertnowextndev${domain}`;
                    this.notiUrl = `https://alertnowdev${domain}/external`;
                    this.brandUrl = `https://ocp-opsnow-brand-site-sandbox.dev.opsnow.com`;
                    this.alertnowInternalOpenApiUrl = `${protocol}//alertnowdev${domain}/opsnow/`;
                    this.opsnow360Url = `${protocol}//consoledev${domain}/`;
            }

            global['urlInfo'] = {
                ssoUrl: this.ssoUrl,
                portalUrl: this.portalUrl,
                noticeUrl: this.noticeUrl,
                permissionUrl: this.permissionUrl,
                chatbotUrl: this.chatbotUrl,
                supportUrl: this.supportUrl,
                extnUrl: '',
                notiUrl: '',
                alertnowInternalOpenApiUrl: this.alertnowInternalOpenApiUrl,
                opsnow360Url: this.opsnow360Url
            };

            return settings;
        });
        return promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/env-load/env-load.service.ts